import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import React, { useContext } from 'react';
import { WrapperField } from '../../../../../components/InputField/WrapperField';
import { DialogContext } from '../../../../../store/context/DialogContext';
import { useTranslation } from '../../../../../store/context/TranslationContext';
import ButtonGroupNew from '../../BusinessLiteForms/components/ButtonGroupNew';
import { getNextStep, getVisibleWizardFieldOrder, WIZARD_NUM } from '../helper';

const MoneyServicesBusiness = ({
    asLabel,
    hideButtons,
    data,
    handleUpdate,
    hasError,
    setHasError,
    loading,
    cyclosFields,
    errors,
    setErrors,
    iPlusFields,
    wizard,
    applicationForm,
    isForEDD,
    handleChange,
    handlePrev,
    setData,
    editMode,
    formType
}) => {
    const { showError } = useContext(DialogContext);
    const { t } = useTranslation();

    const checkNext = () => {
        const visibleFieldOrder = getVisibleWizardFieldOrder({
            fields: iPlusFields,
            wizard,
            data,
        });

        for (const fieldPath of visibleFieldOrder) {
            const fieldError = _.get(errors, fieldPath);
            if (fieldError) {
                setHasError(true);
                if (fieldError) {
                    showError(fieldError);
                    return false;
                }
            }
        }

        setErrors({});
        return true;
    };

    const handleSubmit = () => {
        const isFormFieldValid = checkNext();
        if (isFormFieldValid) {
            setHasError(false);
            return handleUpdate({ nextStep: getNextStep(wizard, applicationForm, data, editMode) });

        }
    };

    const handleUpdateFormData = (updatedData) => {
        handleChange(updatedData);
    };

    const handleErrors = (field, errorMsg) => {
        setErrors((prevErrors) => {
            const updatedErrors = _.cloneDeep(prevErrors);
            updatedErrors[field] = errorMsg;
            return updatedErrors;
        });
    };

    return (
        <div className="row">
            <div className="col-12">

                <div className='mb-3'>
                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["hasUsCustomers"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('hasUsCustomers', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["registeredWithFinCen"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('registeredWithFinCen', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["hasMsbLicense"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('hasMsbLicense', errorMsg)}
                        isForEDD={isForEDD}
                    />

                    <WrapperField
                        disabled={asLabel}
                        jsonField={cyclosFields["msbLicenseLocation"]}
                        dataObj={data}
                        onChange={handleUpdateFormData}
                        showError={hasError}
                        onError={(errorMsg) => handleErrors('msbLicenseLocation', errorMsg)}
                        isForEDD={isForEDD}
                    />

                </div>

                <div className='mt-4'>
                    <ButtonGroupNew
                        onNextClick={handleSubmit}
                        onBackClick={() => { handlePrev() }}
                        step={WIZARD_NUM.MoneyServicesBusiness}
                        showPageNum={false}
                        pageNum={WIZARD_NUM.MoneyServicesBusiness}
                        hideSubmitButton={hideButtons}
                        asLabel={false}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(MoneyServicesBusiness);
